import { query_client } from '$tablet-app/src/app/query_client';
import {
  checklistKeys,
  deleteTaskListMutation,
  listAllChecklistsQuery,
} from '@akin-home/checklists/frontend';
import { createOutputTextItem } from '../../ChatItem/functions';
import { AddChatItemFunction } from '../../types';
import { DeleteChecklistCommand } from '../types';

type Params = {
  command: DeleteChecklistCommand;
  addItem: AddChatItemFunction;
};

export async function deleteChecklistCommand(params: Params) {
  const { command, addItem } = params;

  const result = DeleteChecklistCommand.safeParse(command);

  if (!result.success) {
    console.log('Error: ', result.error);
    return;
  }

  let complete = false;

  const { data } = result.data;

  const { id, title, not_found_message } = data;

  if (id?.length) {
    await deleteTaskListMutation({ input: { id } });
    complete = true;
  } else if (title) {
    const items = await listAllChecklistsQuery({
      query: { title },
    });

    if (items.length > 0) {
      await deleteTaskListMutation({
        input: { id: items[0].id },
      });
      complete = true;
    }
  }

  if (complete) {
    query_client.invalidateQueries(checklistKeys.all);
  } else if (not_found_message) {
    addItem(createOutputTextItem(not_found_message));
  }
}
